export default __webpack_public_path__ + "static/media/slider-5.5c178048.jpg";